import React from 'react';
import { RingLoader } from 'react-spinners';
import { Card, Row } from 'reactstrap';
import { ResponsiveContainer } from 'recharts';
import { safeDeepGet, safeDeepGetWithType } from 'iotera-base/json';
import blank from '../../icons/blank.PNG';
import Textfit from '../../react/react-textfit/lib/Textfit';
import { MaterialLightTooltip } from '../../tooltips';
import { Zoom } from '@material-ui/core';
import IoteraClass from '../../react/react-class';
import { isTextEmpty } from 'iotera-base/text';
import { isNone } from 'iotera-base/object';
import FittedImage from 'react-fitted-image';

// For Unique Id
const uuidv1 = require('uuid/v1');
const infoColor = '#7E57C2';

export class SingleImageCard extends IoteraClass {
    render() {
        let title = safeDeepGet(this, ['props', 'title'], '');
        let pict = safeDeepGet(this, ['props', 'pict'], '');
        let uniqueKey = safeDeepGet(this, ['props', 'id'], '' + uuidv1());

        if (pict === '') {
            pict = blank;
        }
        let view = [];

        let is_loading = safeDeepGet(this, ['props', 'is_loading'], false);

        let date = safeDeepGetWithType(this, ['props', 'date'], '');
        let dateShort = safeDeepGetWithType(this, ['props', 'date_short'], '-');

        let now = "Sesaat yang lalu";

        let primaryValue = safeDeepGet(this, ['props', 'primary', 'value']);
        if (isNone(primaryValue)) {
            primaryValue = safeDeepGet(this, ['props', 'value'], '');
        }

        let primaryColor = safeDeepGet(this, ['props', 'primary', 'color'], infoColor);
        if (isTextEmpty(primaryColor)) {
            primaryColor = safeDeepGet(this, ['props', 'success'], 'BLACK');
        }

        let secondaryValue = safeDeepGet(this, ['props', 'secondary', 'value'], '');
        if (isTextEmpty(secondaryValue)) {
            secondaryValue = safeDeepGet(this, ['props', 'value'], '');
        }
        let secondaryColor = safeDeepGet(this, ['props', 'secondary', 'color'], '');
        if (isTextEmpty(secondaryColor)) {
            secondaryColor = safeDeepGet(this, ['props', 'success'], 'GREY');
        }

        let unitColor = safeDeepGetWithType(this, ['props', 'unitColor'], '#B2B2B2');
        let success = safeDeepGet(this, ['props', 'success'], true);
        let status = safeDeepGet(this, ['props', 'status'], '');
        let imageUrl = safeDeepGet(this, ['props', 'imageUrl'], '');

        let color;

        if (!success) {
            color = '#cc0001';
        } else {
            color = '#7E57C2';
        }

        if ("date" in this.props) {
            if (this.props.date !== '' && this.props.date !== undefined) {
                // TODO bang Widha kalau mau pake date nya berdasarkan string yg d kasih
                now = this.props.date;
                if (now instanceof Date) {
                    now = "Sesaat yang lalu";
                }
            }
        }

        if (!is_loading) {
            view.push(
                <React.Fragment
                    key={title}
                >
                    <div className='container-fluid'>
                        <div className='row' style={{ height: "100%" }}>
                            <div className="col-sm-6"  >
                                <div className='io-row align-items-start' style={{ marginLeft: '10px', marginRight: '10px', marginBottom: '10px', marginTop: '10px' }}>
                                    <span><img src={pict} alt="Logo" style={{ height: '20px', marginRight: '5px' }} /></span>
                                    <span style={{ maxWidth: '80%' }}>
                                        <div style={{ minHeight: 20 }}>
                                            <Textfit height={20} mode="single" max={12} className="h5" style={{ textTransform: 'capitalize', color: '#000', marginBottom: 0, cursor: 'default' }}>
                                                {title}
                                            </Textfit>
                                        </div>
                                        <div className='centeringItemVertical' style={{ height: 14 }}>
                                            <MaterialLightTooltip TransitionComponent={Zoom} title={date} placement="bottom-start" >
                                                <small className="text-gray-300" style={{ cursor: 'default' }}>
                                                    {date}
                                                </small>
                                            </MaterialLightTooltip>
                                        </div>
                                    </span>
                                </div>

                                <ResponsiveContainer height={75} >
                                    <div>
                                        <div>
                                            <div style={{ marginLeft: 10, marginRight: 10 }}>
                                                <div >
                                                    <div style={{ marginBottom: '10px' }}>
                                                        <Textfit height={20} mode="single" max={32} className="h4" style={{ color: primaryColor, textAlign: 'center', cursor: 'default' }}>
                                                            {primaryValue}
                                                        </Textfit>
                                                    </div>
                                                    <div >
                                                        <Textfit height={20} mode="single" max={12} className="h5" style={{ color: '#B2B2B2', textAlign: 'center', cursor: 'default' }}>
                                                            {secondaryValue}
                                                        </Textfit>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ResponsiveContainer>
                            </div>
                            <div className="col-sm-6" style={{ paddingRight: 0 }}>
                                <FittedImage
                                fit='contain'
                                    src={imageUrl}
                                />
                            </div>
                        </div>
                    </div>
                </React.Fragment >
            )
        } else {
            view.push(
                <Card
                    key={title}
                >
                    <Row style={{ marginLeft: '20px', marginRight: '20px', marginBottom: '10px', marginTop: '17px' }}>
                        <div className="loader-content d-flex align-items-center" data-tip data-for={'loading' + uniqueKey}>
                            <RingLoader sizeUnit={"px"} size={26} />

                            <Textfit height={20} mode="single" min={8} max={12} className="h5" style={{ marginLeft: '5px', textTransform: 'uppercase', marginRight: '40px' }}>
                                {title}
                            </Textfit>
                        </div>
                        <MaterialLightTooltip TransitionComponent={Zoom} title={date} placement="left" >
                            <span>Loading data...</span>
                        </MaterialLightTooltip>
                    </Row>
                    <ResponsiveContainer height={75} >
                        <div >

                        </div>
                    </ResponsiveContainer>

                </Card>
            )
        }

        return (
            <div>
                {view}
            </div>
        )
    }
}